<template>
  <div class="container">
    <div class="py-5">
      <h1>{{ $t('menu.tu_carro') }}</h1>
    </div>


     <div class="card-header" v-for="linea in lineas" :key="linea.Id">
       
       <div class="contenedor2ColumnasImageNoticias">
         <img :src="linea.Imagen" style="width: 100%; height:auto" class="card-img-top" />
       </div>
       
       <div class="contenedor2ColumnasImageNoticias2">
          <h1 style="margin-bottom:8px">{{ linea.Nombre }}</h1>
          <div class="card-body">
           <div class="card-text" style="margin-bottom: 15px">
             <a href="#" v-on:click.prevent="removeCarro(linea)" class="btn btn-danger btn-sm">-</a>
                       <span class="border">
                         {{
                         linea.Cantidad
                         }}
                       </span>
             <a href="#" v-on:click.prevent="anyadirAlCarro(linea)" class="btn btn-success btn-sm">+</a>
           </div>
           <div class="card-text" style="margin-bottom: 15px">
             <span style="font-size: 30px; font-weight: 700; margin-top: 10px; color: rgb(48, 48, 48);">{{ linea.Precio }}</span>
           </div>
          </div>
       </div>
       
     </div>
     
     <div style="text-align:center; width:100%">
       <span style="font-size: 40px; font-weight: 700; margin-top: 20px; color: rgb(48, 48, 48);display: block;">{{ importeTotal }}</span><br/>
       <div style="display:block;overflow:hidden; margin-top:10px">
         <router-link to="/">
           <a class="btn btn-info">Continuar comprando</a>
         </router-link>

         <router-link to="/checkout">
           <a class="btn btn-success">Checkout</a>
         </router-link>
       </div>
     </div>

      
      
      
      
      
      
      <!--<div class="table-responsive">
      <table class="table table-stripped">
        <tr v-for="linea in lineas" :key="linea.Id">
          <td style="max-width:300px"><img :src="linea.Imagen" style="width:100%"/></td>
          <td><span style="font-size: 23px; color: #218838;font-weight: 900;font-style: italic;">{{ linea.Nombre }}</span></td>
          <td>
            <a
              href="#"
              v-on:click.prevent="removeCarro(linea)"
              class="btn btn-danger btn-sm"
              >-</a
            >
            <span class="border" style="margin-left: 3px; margin-right: 3px;padding:10px">{{
              linea.Cantidad
            }}</span>
            <a
              href="#"
              v-on:click.prevent="anyadirAlCarro(linea)"
              class="btn btn-success btn-sm"
              >+</a
            >
          </td>
          <td>
            <span style="font-size: 20px; font-weight: 900; color: rgb(48, 48, 48);">{{ linea.Precio }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="text-right">
            <span style="font-size: 25px; font-weight: 900; color: rgb(48, 48, 48);">{{ importeTotal }}</span>
          </td>
        </tr>
      </table>
      </div>
      
    <div class="row">
      <div class="col-md-6">
        <router-link to="/">
          <a class="btn btn-info">Continuar comprando</a>
        </router-link>
      </div>
      <div class="col-md-6" v-if="lineas.length > 0">
        <router-link to="/checkout">
          <a class="btn btn-success">Checkout</a>
        </router-link>
      </div>
    </div>-->
    
    
    
  </div>
</template>
<script>
import Servicios from "../services.js";
export default {
  computed: {
    lineas() {
      console.log("lineas", this.$store.lineas);
      return this.$store.state.lineas;
    },
    importeTotal() {
      return this.$store.getters["getImporteTotal"];
    }    
  },
  methods: {
    anyadirAlCarro(articulo) {
      const cantidadActual = this.$store.getters.getCantidad(articulo);
      if (
        !articulo.ControlStock ||
        cantidadActual + 1 <= articulo.CantidadStock
      ) {
        console.log("anyadirAlCarro => ", articulo);
        this.$store.commit("addLinea", articulo);
      }
    },
    removeCarro(articulo) {
      console.log("removeCarro", articulo);
      this.$store.commit("removeLinea", articulo);
    },
    comprar() {
      console.log("Test");
      //Test
      let pedido = {
        Nombre: "Test",
        Apellidos: "Ap Test",
        Direccion: "Dir Test",
        Email: "Email",
        Telefono: "Telefono",
        Ident: "Ident",
      };
      pedido.Lineas = [];
      for (let i = 0; i < this.$store.state.lineas.length; i++) {
        const l = this.$store.state.lineas[i];
        pedido.Lineas.push({
          IdArticulo: l.Id,
          Cantidad: l.Cantidad,
        });
      }
      let res = Servicios.Comprar(pedido);
      //Fin Test
    },
  },
};
</script>
